import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    btnSearch,
    restartState
} from '../../store/channelmap/reporteparticipacion/actions';

import { Body, Footer, Page } from '@sigeco/tools';
import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/core/Icon';

import ReporteParticipacionPanel from '../../components/channelmap/reporteparticipacion/ReporteParticipacionPanel';
import ReporteParticipacionFilter from '../../components/channelmap/reporteparticipacion/ReporteParticipacionFilter';


const ReporteParticipacion = ({onClose, setTitle}) => {
    const loading = useSelector(state => state.reporteparticipacion.loading);
    const dispatch = useDispatch();

    useEffect(() => {
        setTitle('Dashboard de Participación');
    // eslint-disable-next-line
    }, []);

    function onBtnClose() {
        dispatch(restartState());
        onClose();
    }

    return (
        <Page>
            <Backdrop style={{ position: 'absolute', zIndex: 1200 }} open={loading} transitionDuration={0}>
            <CircularProgress color="inherit" />
        </Backdrop>
        <Body>
            <ReporteParticipacionFilter />
            <ReporteParticipacionPanel />
        </Body>
        <Footer>
            <Button
                color="primary"
                size="small"
                variant="outlined"
                onClick={() => dispatch(btnSearch())}
                startIcon={<Icon className="fas fa-search"/>}
            >
                Buscar
            </Button>
            <Button 
                color="primary" 
                size="small" 
                variant="outlined" 
                onClick={() => onBtnClose()} 
                startIcon={<Icon className="fas fa-door-open"/>}
            >
                Salir
            </Button>
        </Footer>
        </Page>
    )
};

export default ReporteParticipacion;